import posthog from 'posthog-js';
import type { TrackClickEvent } from './types';

export const trackClick = async ({
  name,
  eventProperties = {},
}: TrackClickEvent) => {
  posthog.capture(name, {
    ...eventProperties,
  });
};
